import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    PlannedConsultationCardList: {
        position: 'relative',
    },
    PlannedConsultationCardListCount: {
        position: 'absolute',
        top: '-2.7rem',
        left: 0,
    },
    PlannedConsultationCardListCountText: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.main,
    },
    PlannedConsultationCardListContent: {},
    PlannedConsultationCardListMainContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        maxWidth: '1616px',
        width: '100%',
        margin: '0 auto',
    },
     PlannedConsultationHeaderWrapper: {
        width: '100%',
        borderBottom: `1px solid ${theme.palette.lightGrey.dark}`,
    },
    PlannedConsultationHeaderButtonsContainer: {
        marginBottom: '0.5rem',
    },
    PlannedConsultationCards: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '2.5rem',
    },
    PlannedConsultationCardsInner: {
        width: '100%',
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        flexWrap: 'wrap',
        gap: '.9rem',
    },
    PlannedConsultationCardsButonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    PlannedConsultationCardsButonContainerMore: {
        marginTop: '2.5rem',
    },
    PlannedConsultationCardWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(820)]: {
            width: 'calc(50% - .9rem)',
        },
        '@media (min-width: 1300px) and (max-width: 1500px)': {
            width: 'calc(33.333% - .9rem) !important',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(1600)]: {
            width: 'calc(25% - .9rem)',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(2000)]: {
            width: 'calc(20% - .9rem)',
        },
    },
    PlannedConsultationCardWrapperPreview: {
      // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(1300)]: {
            width: 'calc(25% - .9rem)',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(1600)]: {
            width: 'calc(25% - .9rem)',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(2000)]: {
            width: 'calc(25% - .9rem)',
        },
    },
    PlannedConsultationCard: {
        width: '100%',
        padding: '2rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `1px solid ${theme.palette.lightGrey.half}`,
        boxShadow: '0px 6px 18px rgba(7,164,165,0.11)',
        borderRadius: '12px',
        background: '#ffffff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
    },
    PlannedConsultationCardHeaderDelete: {
        padding: '0',
        border: `1.5px solid #FB355D`,
        borderRadius: '10px',
        width: '34px',
        minWidth: '34px',
        height: '34px',
        margin: '-6px 0',
        '& svg': {
          width: '18px',
          height: '18px',
        },
    },
    PlannedConsultationCardHeader: {
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `2px solid ${theme.palette.lightGrey.harder}`,
        borderRadius: '9px',
        padding: '.7rem 1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem',
        gap: '1.5rem',
        [theme.breakpoints.between(1400, 1450)]: {
            gap: '0.5rem',
        },
    },
    PlannedConsultationCardHeaderItem: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.5rem',
    },
    PlannedConsultationCardContent: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '1rem',
        flex: 1,
    },
    PlannedConsultationCardContentItem: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '.2rem',
    },
    PlannedConsultationCardContentItemLabel: {
        fontSize: '.85rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.medium,
    },
    PlannedConsultationCardContentItemValue: {
        fontSize: '1.15rem',
        wordBreak: 'break-word',
    },
    PlannedConsultationCardContentItemInfo: {
        fontWeight: 400,
        fontSize: '.9rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.half,
    },
    PlannedExpertiseCardContentItemSpeciality: {
        fontFamily: 'AvertaPE-Regular',
        fontSize: '14px',
        fontWeight: '400',
        color: '#4E5054',
    },
    PlannedConsultationCardBottom: {
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        borderTop: `1px solid${theme.palette.lightGrey.dark}`,
        marginTop: '1rem',
        paddingTop: '1rem',
    },
    PlannedConsultationCardBottomInfo: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
    },
    PlannedConsultationCardBottomInfoIcon: {
        width: '2rem',
        height: '2rem',
    },
    PlannedConsultationCardBottomInfoLabel: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.mediumDark,
    },
    PlannedConsultationCardBottomButtonContainer: {
        width: '100%',
    },
    PlannedConsultationCardBottomButton: {
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.consultation.main,
        marginTop: '1rem',
        gap: '.5rem',
        '&:hover': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            background: theme.palette.consultation.hover,
        },
    },
    PlannedConsultationCardBottomButtonIcon: {
        width: '1rem',
        height: '1rem',
    },
    PlannedConsultationCardBottomButtonLabel: {
        color: '#ffffff',
    },
    PlannedConsultationCardOverdue: {
        // boxShadow: `0px 6px 18px ${theme.palette.red.shadow}`,
    },
    PlannedConsultationCardHeaderOverdue: {
        '& *': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            color: theme.palette.red.main,
        },
    },
    PlannedConsultationCardBottomButtonOverdue: {
        // background: theme.palette.red.main,
        // '&:hover': {
        //     background: theme.palette.red.hover,
        // },
    },
    PlannedConsultationCardOverdueText: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.red.main,
        fontSize: '.8rem',
        maxWidth: '20rem',
        marginTop: '1rem',
        marginBottom: '1rem',
    },
    PlannedConsultationHeader: {
        maxWidth: '1616px',
        width: '100%',
        margin: '0 auto',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        borderBottom: `1px solid ${theme.palette.lightGrey.dark}`,
    },
    PlannedConsultationHeaderLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
    },
    PlannedConsultationHeaderTitleContainer: {},
    PlannedConsultationHeaderTitle: {
        fontSize: '1.6rem',
        fontWeight: '800',
    },
    PlannedConsultationHeaderTitleContainerCount: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.5rem',
    },
    PlannedConsultationHeaderTitleContainerCountButton: {
        padding: '.3rem',
        textDecoration: 'underline',
    },
    PlannedConsultationHeaderRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '0.5rem',
    },
    PlannedConsultationHeaderSearch: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `2px solid ${theme.palette.lightGrey.dark}`,
        borderRadius: '9px',
        background: '#ffffff',
        minWidth: '0',
        '& fieldset': {
            border: 'none',
        },
        '& .MuiInputBase-input': {
            height: '1.75rem',
            padding: '.75rem',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(820)]: {
            minWidth: '22rem',
        },
    },
    PlannedConsultationHeaderSearchLabel: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.5rem',
        top: '-2rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.mediumDark,
    },
    PlannedConsultationHeaderSearchDialogPaper: {
        width: '90%',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(820)]: {
            width: 'auto',
        },
    },
    PlannedConsultationCardsNoPreviewBottom: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '.7rem',
    },
    PlannedConsultationCardsEndOfList: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.light,
    },
    PlannedConsultationCardsCountContainer: {
        marginBottom: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '.7rem',
    },
    PlannedConsultationCardsCount: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.light,
    },
    PlannedConsultationCardsCountContainerLoadbar: {
        width: '80%',
        height: '4px',
        borderRadius: '100px',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.lightGrey.medium,
    },
    PlannedConsultationCardsCountContainerLoadbarProgress: {
        height: '100%',
        borderRadius: '100px',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.primary.main,
    },
    PlannedConsultationCardListLoading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '4rem 0',
    },
    PlannedConsultationCardListLoadingLoader: {
        '&::before': {
            borderWidth: '6px',
        },
    },
    PlannedConsultationCardListLoadingMessage: {
        marginTop: '1rem',
        fontSize: '1.4rem',
    },
}))
